import React from "react";
import { motion } from "motion/react";
import { useOutletContext } from "react-router-dom";

import { useAuth } from "../contexts/AuthContext";
import { useBrand } from "../contexts/BrandContext";
import Message from "../components/ui-new/Message";
import MessageInput from "../components/ui-new/MessageInput";
import defaultSuggestedSearches from "../consts/suggestedSearches.json";

export default function LandingPage() {
  const { message, updateMessage, sendMessage, applyMacro } =
    useOutletContext();
  const { user, isLoading } = useAuth();
  const { brand } = useBrand();

  // Use brand-specific suggested searches, falling back to defaults
  const suggestedSearches = brand?.navigation?.suggestedSearches || defaultSuggestedSearches;

  // Function to truncate name if it's too long
  const truncateName = (name, maxLength = 20) => {
    if (!name) return "You";
    return name.length > maxLength
      ? `${name.substring(0, maxLength)}...`
      : name;
  };

  return (
    <div className="relative min-h-[100dvh] w-full overflow-hidden flex justify-center items-center font-sans font-light">
      {/* Suggestion bubbles and message input container */}
      <div className="fixed bottom-0 flex flex-col z-30 w-full max-w-[700px] px-4 sm:px-6 md:relative md:px-0">
        {/* Suggestion bubbles */}
        <div className="flex flex-wrap justify-center mb-4 md:mb-6 w-full max-w-[700px] mx-auto gap-3">
          {suggestedSearches?.map((suggestion, index) => (
            <Message
              sender="suggestion"
              transition={{
                duration: 0.2,
                delay: index * 0.02,
                ease: "easeOut",
              }}
              key={index}
              onClick={() => applyMacro(suggestion)}
            >
              {suggestion}
            </Message>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          className="flex justify-center z-50 w-full max-w-[700px]"
        >
          <MessageInput
            value={message}
            onChange={updateMessage}
            onSubmit={sendMessage}
            placeholder={
              <>
                {isLoading ? (
                  <div></div>
                ) : (
                  <>
                    Hey{" "}
                    <span className="font-sans font-normal text-penta-black inline-block mx-1">
                      {user?.firstName ? truncateName(user.firstName) : "You"}
                    </span>
                    , what are you looking for today?
                  </>
                )}
              </>
            }
            buttonText={"Submit"}
            disabled={!message.trim()}
          />
        </motion.div>
      </div>
    </div>
  );
}
